import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import ProductRowItem from "./ProductRowItem";
import Skeleton from "../../components/Skeleton";
import { useLocation, useParams } from "react-router-dom";

export const PRODUCT_OUTLINE = [
  { api_name: "cartActions", show_name: "Actions", aligment: "center" },
  { api_name: "something", show_name: "Image", aligment: "start" },
  { api_name: "Product_Code", show_name: "via Code", aligment: "center" },
  { api_name: "Product_Name", show_name: "via Name", aligment: "center" },
  // { api_name: "Product_Type", show_name: "Product Type" },
  { api_name: "Description", show_name: "Description", aligment: "center" },
  { api_name: "Unit_Price", show_name: "List Price", aligment: "right" },
  {
    api_name: "Distributors_Discount_Price",
    show_name: "Distributors Discount Price",
    aligment: "right",
  },
  { api_name: "Usage_Unit", show_name: "UOM", aligment: "center" },
  { api_name: "bondedStock", show_name: "Bonded Stock", aligment: "center" },
  {
    api_name: "nonBondedStock",
    show_name: "Non-Bonded Stock",
    aligment: "center",
  },
  {
    api_name: "Minimum_Order_level",
    show_name: "Min Order Qty",
    aligment: "right",
  },
];

const PRODUCT_SKELATON_OUTLINE = [
  { h: "3", w: "96" },
  { h: "10", w: "10" },
  { h: "3", w: "96" },
  { h: "3", w: "96" },
  { h: "3", w: "96" },
  { h: "3", w: "96" },
  { h: "3", w: "96" },
  { h: "3", w: "96" },
  { h: "3", w: "96" },
  { h: "3", w: "96" },
  { h: "3", w: "96" },
];

const ProductLists = ({
  products,
  isLoading,
  searchValues,
  setSearchValues,
  setFormData,
  handleRemoveFavorite,
  isReturn,
}) => {
  const [cart, setCart] = useState([]);
  const [sticky, setsticky] = useState('sticky');
  const location = useLocation();
  const { orderId } = useParams(); // Get the order ID from the URL
  const inPurchaseOrder =
    location.pathname.startsWith("/purchase-order") && orderId !== "new";
  const inproducts = location.pathname.startsWith("/products");
  const constructedWithSaveId = `order_${orderId}`;

  // Load the cart from localStorage when the component mounts
  useEffect(() => {
    // const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    let currentPurchase;
    if (inPurchaseOrder) {
      currentPurchase = JSON.parse(localStorage.getItem(constructedWithSaveId));
    } else {
      currentPurchase = JSON.parse(localStorage.getItem("current_purchase"));
    }
    if (currentPurchase?.Orders_Items) {
      setCart(currentPurchase?.Orders_Items);
    }
  }, [constructedWithSaveId, inPurchaseOrder]);

  const updateLocalStorage = (product) => {
    // Fetch current_purchase from local storage
    const currentPurchase = JSON.parse(
      localStorage.getItem(
        inPurchaseOrder ? constructedWithSaveId : "current_purchase"
      )
    ) || {
      Dealer_Name: "",
      Delivery_Date: "",
      CP_Purchase_Owner: "",
      Date: "",
      Stage: "",
      Orders_Items: [],
    };
    currentPurchase["Orders_Items"] = product;
    if (setFormData)
      setFormData((val) => {
        return {
          ...val,
          ...currentPurchase,
        };
      });
    // Save updated current_purchase back to local storage
    localStorage.setItem(
      inPurchaseOrder ? constructedWithSaveId : "current_purchase",
      JSON.stringify(currentPurchase)
    );
  };

  // Function to handle adding a product to the cart
  const handleAddCart = (product) => {
    if (!cart.some((item) => item.id === product.id)) {
      const updatedCart = [...cart, product];
      updateLocalStorage(updatedCart);
      setCart(updatedCart);
      toast.success("Successfully Added!");
    }
  };

  // Function to handle removing a product from the cart
  const handleRemoveCart = (id) => {
    const updatedCart = cart.filter((item) => item.id !== id);
    updateLocalStorage(updatedCart);
    setCart(updatedCart);
    toast.success("Successfully Removed!");
  };

  // console.log({ products });

  const isForDefaultUrl = location.pathname.startsWith("/purchase-order/new");
  return (
    <div
      className={`relative overflow-auto  shadow-md sm:rounded-lg ${
        isForDefaultUrl ? "h-[360px]" : "max-h-[75vh]"
      }`}
    >
      <table className="w-full h-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            {PRODUCT_OUTLINE.map(
              ({ api_name, show_name, aligment = "left" }, index) => (
                <th
                  key={show_name}
                  scope="col"
                  className={`px-6 py-3 text-${aligment} ${
                    index === 0 ? `${sticky} left-0 z-10 bg-[#f9fafb]` : ""
                  }
                  ${
                    index < 2 && index >= 1 && isForDefaultUrl && products && !isLoading
                      ? `${sticky} left-[127px] z-10 bg-[#f9fafb]`
                      : index < 2 && index >= 1 && products && !isLoading
                      ? `${sticky} left-[180px] z-10 bg-[#f9fafb]`
                      : ""
                  }
                  
                  `}
                >
                  {["Product_Code", "Product_Name", "Product_Type"].includes(
                    api_name
                  ) ? (
                    <input
                      type="text"
                      placeholder={`Search ${show_name}`}
                      value={searchValues[api_name]}
                      onChange={(e) =>
                        setSearchValues((searchValues) => {
                          return {
                            ...searchValues,
                            [api_name]: e.target.value,
                            page: 1,
                          };
                        })
                      }
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block min-w-14 py-1.5 px-3 dark:bg-gray-700 dark:border-gray-600 dark:text-white w-36"
                    />
                  ) : ["Description"].includes(api_name) ? (
                    <span className="min-w-20 inline-block w-44">
                      {show_name}
                    </span>
                  ) : (
                    <span className="min-w-20 inline-block">{show_name}</span>
                  )}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {!isLoading && !products && !products?.length ? (
            <tr>
              <td
                colSpan={PRODUCT_OUTLINE.length}
                className={`text-center text-yellow-400 text-lg font-bold py-5`}
              >
                <h1>No Product Match</h1>
              </td>
            </tr>
          ) : isLoading ? (
            [...Array(14).keys()].map((_, index) => (
              <tr key={index}>
                {PRODUCT_SKELATON_OUTLINE.map(({ h, w }, index) => (
                  <td key={index} className="relative p-4">
                    <Skeleton
                      className={`h-${h} w-${w} inline-block mx-auto`}
                    />
                  </td>
                ))}
              </tr>
            ))
          ) : (
            products?.map((product) => (
              <ProductRowItem
                key={product.id} // Add the key prop here
                product={product}
                cart={cart}
                handleRemoveCart={handleRemoveCart}
                handleAddCart={handleAddCart}
                handleRemoveFavorite={handleRemoveFavorite}
                isReturn={isReturn}
                setsticky={setsticky}
                sticky={sticky}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProductLists;
